export const ERROR_CODE = {
  NETWORK: 'ERR_NETWORK',
  ERR_BAD_RESPONSE: 'ERR_BAD_RESPONSE',
  SERVICE_UNAVAILABLE: 503,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  LOCKED: 423,
  CUSTOM_CODE: 451, // CUSTOM CODES
  NO_ACCESS: 1403,
  UNABLE_TO_DELETE_STATUS_IN_USE: 43003,
  UNABLE_TO_DELETE_INTERNSHIP_STATUS_IN_USE: 43007,
  CANDIDATE_DUPLICATE_SOFT: 40001,
  CANDIDATE_DUPLICATE_HARD: 40002,
  GOOGLE_UNAVAILABLE: 41001
};

export enum ErrorModalTypes {
  CANDIDATE_DUPLICATE = 'CANDIDATE_DUPLICATE',
  NETWORK_ERROR = 'NETWORK_ERROR',
  NO_ACCESS = 'NO_ACCESS',
  FORBIDDEN = 'FORBIDDEN',
}
